// extracted by mini-css-extract-plugin
export default {"mag_home_videos_container":"videos-tab_mag_home_videos_container__a82Vz"};